<template>
    <div class="calendar-filter-week-button" @click="scrollToWeek">
        <span class="font-medium">Semaine {{ week }}</span>
    </div>
</template>

<script>
export default {
    name: "CalendarFilterWeekButton",
    props: {
        week: Number
    },
    methods: {
        scrollToWeek() {
            const target = document.getElementById('calendar-week-' + this.week)
            const cardWeekFilter = document.getElementById('calendar-filter-week')
            let offset = 160
            if(!(cardWeekFilter.style.position === 'fixed')) {
                offset = 265
            }
            const position = (target.getBoundingClientRect().top + window.scrollY) - offset
            window.scrollTo({
                top: position,
                behavior: 'smooth'
            })
        }
    }
}
</script>

<style scoped>

</style>
